import { navV3Messages } from '@/components/layout/Navigation/nav-v3/nav-v3.messages';
import { NavItem } from '@/components/layout/Navigation/sidebar/nav-item';
import { useIsWorkflowsEnabled } from '@/features/flags';
import { useOpenRoutinesSurface } from '@/features/workflows/hooks/useOpenRoutinesSurface';
import {
  currentWorkHomeViewAtom,
  currentWorkflowSelectionAtom,
  pendingWorkHomeViewAtom,
} from '@heidi/agents/data';
import { Routines } from '@heidi/design-system/icons';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMobilePanel } from '../../mobile/use-mobile-panel';

/** Nav-v3 Routines entry for the Work home's routines view. */
export const RoutinesNavItem = () =>
  useIsWorkflowsEnabled() ? <EnabledRoutinesNavItem /> : null;

const EnabledRoutinesNavItem = () => {
  const intl = useIntl();
  const currentWorkHomeView = useAtomValue(currentWorkHomeViewAtom);
  const pendingWorkHomeView = useAtomValue(pendingWorkHomeViewAtom);
  const currentWorkflowSelection = useAtomValue(currentWorkflowSelectionAtom);
  const openRoutines = useOpenRoutinesSurface();
  const { dismissMobileSidebar } = useMobilePanel();

  const onClick = useCallback(() => {
    openRoutines(null);
    dismissMobileSidebar();
  }, [openRoutines, dismissMobileSidebar]);

  return (
    <NavItem
      label={intl.formatMessage(navV3Messages.routines)}
      icon={<Routines />}
      onClick={onClick}
      isActive={
        pendingWorkHomeView === 'skills' ||
        (pendingWorkHomeView === null &&
          currentWorkHomeView === 'skills' &&
          currentWorkflowSelection === null)
      }
      testId="sidebar-link-routines"
    />
  );
};
